/**
 * CompareTray — Bandeau sticky bottom qui affiche les biens sélectionnés
 * pour comparaison. Visible globalement quand 1+ bien est ajouté.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Scale, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useCompare } from '../hooks/useCompare';
import { formatPrice } from '../data/mockData';

const CompareTray = () => {
  const { items, remove, clear, max } = useCompare();
  const navigate = useNavigate();

  if (items.length === 0) return null;

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 w-[min(95vw,860px)]"
      data-testid="compare-tray"
    >
      <div className="bg-stone-900/95 backdrop-blur-xl text-white rounded-2xl shadow-2xl ring-1 ring-white/10 px-4 py-3">
        <div className="flex items-center gap-3">
          <div className="hidden sm:flex h-9 w-9 items-center justify-center rounded-full bg-brand-600/90 flex-shrink-0">
            <Scale className="h-4 w-4 text-white" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs text-stone-300 mb-1">
              Comparateur ({items.length}/{max})
            </p>
            <div className="flex items-center gap-2 overflow-x-auto">
              {items.map((p) => (
                <div
                  key={p._id || p.id}
                  className="group relative flex items-center gap-2 bg-white/10 hover:bg-white/15 transition-colors rounded-lg pl-1.5 pr-2 py-1 flex-shrink-0"
                  data-testid={`compare-item-${p._id || p.id}`}
                >
                  <img
                    src={p.images?.[0]}
                    alt=""
                    className="h-8 w-10 rounded object-cover"
                  />
                  <div className="text-xs">
                    <p className="font-semibold leading-tight truncate max-w-[120px]" title={p.title}>{p.title}</p>
                    <p className="text-stone-400 leading-tight">{formatPrice(p.price)}</p>
                  </div>
                  <button
                    type="button"
                    onClick={() => remove(p._id || p.id)}
                    className="ml-1 text-stone-300 hover:text-white transition-colors"
                    aria-label="Retirer"
                  >
                    <X className="h-3.5 w-3.5" />
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="flex items-center gap-1.5 flex-shrink-0">
            <Button
              size="sm"
              variant="ghost"
              onClick={clear}
              className="hidden sm:inline-flex text-stone-300 hover:text-white hover:bg-white/10 text-xs"
              data-testid="compare-clear-btn"
            >
              Tout retirer
            </Button>
            <Button
              size="sm"
              onClick={() => navigate('/compare')}
              disabled={items.length < 2}
              className="bg-brand-600 hover:bg-brand-700 text-white text-xs font-semibold disabled:opacity-50"
              data-testid="compare-go-btn"
            >
              Comparer
              <ArrowRight className="h-3.5 w-3.5 ml-1" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompareTray;
